// Add new feature flags here.
export enum Flag {
	// --- Test Flags ---
	TestFlagTrue = "TEST_FLAG_TRUE",
	TestFlagFalse = "TEST_FLAG_FALSE",

	// --- Feature Flags ---
	CanvasLayoutVisualDebug = "CANVAS_LAYOUT_VISUAL_DEBUGGING",
	GitBranching = "GIT_BRANCHING",
	DisplayMarkdownEditor = "DISPLAY_MARKDOWN_EDITOR",

	ShareTab = "SHARE_TAB",

	CollabEditing = "COLLAB_EDITING",
}

export const allFlags = Object.values(Flag);

export const initialFlags = allFlags.map((flag) => ({
	id: flag,
	enabled: false,
}));

export type FeatureFlag = {
	id: Flag;
	enabled: boolean;
};
